
import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch invoice list for tax
 * @param {Object} filters list filters
  * @param {Number} filters.page list page
  * @param {Number} filters.size list size
  * @param {String} filters.sort list sorting
  * @param {Number} filters.from list date from
  * @param {Number} filters.to list date to
  * @param {String} filters.clientType client type
  * @param {Number} filters.shipperId client shipper id
 */
const taxlist = async function (filters) {
  try {
    let data = {
      ...filters,
      page: filters.page - 1
    }
    let res = await axios.get(urls.taxList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch invoice list for tax download csv
 * @param {Object} filters list filters
 * @param {Number} filters.from list date from
 * @param {Number} filters.to list date to
 * @param {String} filters.clientType client type
 * @param {Number} filters.shipperId client shipper id
 */

const taxlistcsv = async function (filters) {
  try {
    let data = {
      ...filters,
      page: filters.page - 1
    }
    let res = await axios.get(urls.taxListCsv + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  taxlist,
  taxlistcsv
}
